/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('Activity_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBookingS = $resource(baseUrl + 'rest/activities/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' },
            saveTransaction :  { method: 'POST', url: baseUrl + 'rest/activities/saveTransaction'}
        });
        return resourceBookingS;
    }]);

angular.module('FlexyBeautyApp.services').
factory('Activity',["Activity_Resource","ActivityData","Period","DayHrData","DayData",
        function (Activity_Resource,ActivityData,Period,DayHrData,DayData)
        {


    var  Activity = function (activityRes,isPreviousVersion, isApplicationLoading)
    {
        this.id = null;
        this.label = null;
        this.period = null

        this.dayHr=null;   //if linked to dayHR; activity of a day of year
        this._dayHr = null; //tmp value for loading
        this._dayHrId = null; //tmp value for loading
        this.dayPr=null;   //if linked to dayPR; activity of a day of year
        this._dayPr = null; //tmp value for loading
        this._dayPrId = null; //tmp value for loading
        this.workingPeriodDayHr = null;//if linked to workingPeriodDayHr; activity of the standard week
        this.workingPeriodDayPr = null;//if linked to workingPeriodDayPr; activity of the standard week
        this.parentActivityId = null;
        this.version = null;
        if (activityRes!==undefined && activityRes!=null)
            this.loadObject(activityRes,isPreviousVersion, isApplicationLoading);

        if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
            ActivityData.add(this, isApplicationLoading);
    }
    Activity.prototype.loadObject = function(object, isPreviousVersion, isApplicationLoading)
    {
        if (!this.id)
            this.id = object.id;
        this.label = object.label;
        this.setPeriod(object.period);
        this.parentActivityId = object.parentActivityId;
        var dayHr;
        if (object.dayHrId)
            this._dayHrId =object.dayHrId;//preserve id for loading booking
        if (object.dayHr)
            this._dayHr =object.dayHr; //preserve id for loading booking
        if (object.dayPrId)
            this._dayPrId =object.dayPrId;//preserve id for loading booking
        if (object.dayPr)
            this._dayPr =object.dayPr; //preserve id for loading booking
        if (object.version)
            this.version = object.version;

    }

    Activity.prototype.setPeriod = function(period)
    {
        if (period)
        {
            this.period = new Period(period)

        }
        else
            this.period =null;
    }
    Activity.prototype.copyDataTo = function(object)
    {
        object.id=this.id;
        object.label=this.label;

        if (this.parentActivityId)
            object.parentActivityId = this.parentActivityId;

        if (this.period)
        {
            object.period = this.period.getObjectResource();
        }

        if (this.dayHr!=null)
            if (this.dayHr.getId()==null)
                object.dayHr = this.dayHr.getObjectResourceCreatedByActivity(); //Inject dayHr directly in order to let the server create it
            else
                object.dayHrId = this.dayHr.getId();

        if (this.dayPr!=null)
            if (this.dayPr.getId()==null)
                object.dayPr = this.dayPr.getObjectResourceCreatedByActivity(); //Inject dayPr directly in order to let the server create it
            else
                object.dayPrId = this.dayPr.getId();

        if (this.workingPeriodDayHr!=null)
            object.workingPeriodDayHrId = this.workingPeriodDayHr.getId();

        if (this.workingPeriodDayPr!=null)
            object.workingPeriodDayPrId = this.workingPeriodDayPr.getId();
    }

    Activity.prototype.getObjectResource = function()
    {
        var activityRes = new Activity_Resource();
        this.copyDataTo(activityRes);
        return activityRes;
    }

    Activity.prototype.setIdUsingObject = function(object)
    {
        this.id = object.id;
    }
    Activity.prototype.setId = function(id)
    {
        this.id = id;
    }
    Activity.prototype.getId = function()
    {
        return this.id;
    }

    Activity.prototype.setHumanResource = function(humanResource)
    {
        //if (this.humanResource!=null && this.humanResource!= humanResource)
            //this.humanResource.removeActivity(this);
        this.humanResource = humanResource;
        if (this.humanResource!=null)
        {
//            this.humanResource.addActivity(this);
        }

    }
    Activity.prototype.getHumanResource = function()
    {
        return this.humanResource;

    }


    Activity.prototype.removeFromDayHr = function()//Boolean
    {
        if (this.dayHr)
            this.dayHr.removeActivity(this);
    }

    return Activity;
}]);

angular.module('FlexyBeautyApp.services').factory('ActivitySrv',["$rootScope",
            "$log", "ServerSrv", "Activity_Resource", "UserActionData", "ActivityData", "Activity", "DayHrData",
            "WorkingPeriodDayHrData", "$timeout", "DayPrData", "WorkingPeriodDayPrData",
        function ($rootScope, $log, ServerSrv, Activity_Resource, UserActionData, ActivityData, Activity, DayHrData,
                  WorkingPeriodDayHrData, $timeout, DayPrData, WorkingPeriodDayPrData) {
        var  activitySrv = {};

        activitySrv.save =  function(activity,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(activitySrv.saveSync, activity, successFunction, errorFunction);
        };
        activitySrv.saveSync =  function(activity,successFunction,errorFunction)
        {
            if(!$rootScope.readOnly) {
                var activityRes = activity.getObjectResource();
                activityRes.$save({}, //no params
                    function (activityRes) {
                        try {
                            //CallBack on success
                            activity.setId(activityRes.id);
                            if (!activity.version || (activityRes.version && activityRes.version > activity.version))
                                activity.version = activityRes.version;
                            if (activity.dayHr && !activity.dayHr.id && activityRes.dayHrId)
                                activity.dayHr.id = activityRes.dayHrId;
                            if (activity.dayPr && !activity.dayPr.id && activityRes.dayPrId)
                                activity.dayPr.id = activityRes.dayPrId;
                            //Add user action
                            UserActionData.add(activityRes.userAction);

                            if (successFunction !=undefined)
                                successFunction(activityRes);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        $log.error("ActivitySrv.save - error");
                        $log.error(data);
                        try {
                            if (errorFunction != undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            }
        };

        activitySrv.saveTransaction =  function(transaction,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(activitySrv.saveTransactionAsync, transaction, successFunction, errorFunction);
        };
        activitySrv.saveTransactionAsync =  function(transaction,successFunction,errorFunction)
        {
            if (transaction && transaction.objects && transaction.objects.length>0)
            {
                var transactionResource = new Activity_Resource();
                transactionResource.activities = [];
                for (var i=0;i<transaction.objects.length;i++)
                    transactionResource.activities.push(transaction.objects[i].getObjectResource());
                transactionResource.$saveTransaction({}, //no params
                    function (data) {
                        try {
                            var activity;
                            var activityRes;
                            if (data.activities && transaction.objects.length ==data.activities.length)
                                for (var i=0;i<transaction.objects.length;i++)//Consider order must be the same
                                {
                                    activity = transaction.objects[i];
                                    activityRes = data.activities[i];
                                    activity.setId(activityRes.id);
                                    if (!activity.version || (activityRes.version && activityRes.version > activity.version))
                                        activity.version = activityRes.version;
                                    if (activity.dayHr && !activity.dayHr.id && activityRes.dayHrId)
                                        activity.dayHr.id = activityRes.dayHrId;
                                    if (activity.dayPr && !activity.dayPr.id && activityRes.dayPrId)
                                        activity.dayPr.id = activityRes.dayPrId;

                                }
                            else
                                $log.error("saveTransactionAsync : returned list size incorrect !!");

                            //Add user action
                            UserActionData.add(data.userAction);
                            //CallBack on success
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null), "Activity.saveTransactionAsync - Error on save and server call queue not empty");
                        }
                    }
                );

            }
            else
                ServerSrv.endSavingProcess(true);
        };
        activitySrv.remove =  function(activity,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(activitySrv.removeSync, activity, successFunction, errorFunction);
        };
        activitySrv.removeSync =  function(activity,successFunction,errorFunction)
        {
            var activityRes = new Activity_Resource();
            activityRes.$remove({id: activity.id}, //no params
                function (data) {
                    try {
                        //Add user action
                        UserActionData.add(data.userAction);

                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false, (data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };

        activitySrv.updateLocally = function(id, resource) {
            let activity = ActivityData.getById(id);
            if (activity != null) {
                if (activity.version && resource.version && resource.version < activity.version) {
                    return null;
                }
                activity.loadObject(resource);
                if (resource.dayHrId) {
                    let dayHr = DayHrData.getById(resource.dayHrId);
                    if (activity.dayHr !== dayHr) {
                        if (activity.dayHr) {
                            activity.dayHr.removeActivity(activity);
                        }
                    }
                    if (dayHr) {
                        dayHr.addActivity(activity);
                    } else {
                        console.log("Activity.updateLocally - DayHr not found given ID in resource - DayHR ID: " + resource.dayHrId);
                    }
                } else if (activity.workingPeriodDayHrId) {
                    let workingPeriodDayHr = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
                    if (activity.workingPeriodDayHr !== workingPeriodDayHr) {
                        if (activity.workingPeriodDayHr) {
                            activity.workingPeriodDayHr.removeActivity(activity);
                        }
                    }
                    if (workingPeriodDayHr) {
                        workingPeriodDayHr.addActivity(activity);
                    } else {
                        console.log("Activity.updateLocally - WorkingPeriodDayHr not found given ID in resource - WorkingPeriodDayHr ID: " + resource.workingPeriodDayHrId);
                    }
                }
                if (resource.dayPrId) {
                    let dayPr = DayPrData.getById(resource.dayPrId);
                    if (activity.dayPr !== dayPr) {
                        if (activity.dayPr) {
                            activity.dayPr.removeActivity(activity);
                        }
                    }
                    if (dayPr) {
                        dayPr.addActivity(activity);
                    } else {
                        console.log("Activity.updateLocally - DayPr not found given ID - DayPR ID: " + resource.dayPrId);
                    }
                } else if (activity.workingPeriodDayPrId) {
                    let workingPeriodDayPr = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);
                    if (activity.workingPeriodDayPr !== workingPeriodDayPr) {
                        if (activity.workingPeriodDayPr) {
                            activity.workingPeriodDayPr.removeActivity(activity);
                        }
                    }
                    if (workingPeriodDayPr) {
                        workingPeriodDayPr.addActivity(activity);
                    } else {
                        console.log("Activity.updateLocally - WorkingPeriodDayPr not found given ID - WorkingPeriodDayPr ID: " + resource.workingPeriodDayPrId);
                    }
                }
            }
            return activity;
        };

        activitySrv.removeLocally = function(id, resource) {
            let activity = ActivityData.getById(id);
            if (activity != null) {
                if (activity.version && resource.version && resource.version < activity.version) {
                    return null;
                }

                if (activity.workingPeriodDayHr) {
                    activity.workingPeriodDayHr.removeActivity(activity);
                }
                if (activity.dayHr) {
                    activity.dayHr.removeActivity(activity);
                }
                if (activity.workingPeriodDayPr) {
                    activity.workingPeriodDayPr.removeActivity(activity);
                }
                if (activity.dayPr) {
                    activity.dayPr.removeActivity(activity);
                }
            } else {
                console.log("Activity.removeLocally - Model not found given ID - Activity ID: " + id);
            }
            return activity;
        };

        activitySrv.addLocally = function(id, resource) {
            let activity = ActivityData.getById(id);
            if (activity && activity.version && resource.version && resource.version < activity.version) {
                return null;
            }

            if (activity != null) { //check if resource already exist inside index (current action could be a 'cancel')
                activity.loadObject(resource);
                console.log("Activity.addLocally - Model already exists - Activity ID: " + id);
            } else {
                activity = new Activity(resource);
                activity.id = id; //Force set id because resource could be a previous version
            }
            if (resource.dayHrId) {
                let dayHr = DayHrData.getById(resource.dayHrId);
                if (dayHr) {
                    dayHr.addActivity(activity);
                }  else {
                    console.log("Activity.addLocally - DayHr not found given ID - DayHR ID: " + resource.dayHrId);
                }
            } else if (activity.workingPeriodDayHrId) {
                let workingPeriodDayHr = WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
                if (workingPeriodDayHr) {
                    workingPeriodDayHr.addActivity(activity);
                } else {
                    console.log("Activity.addLocally - WorkingPeriodDayHr not found given ID - WorkingPeriodDayHr ID: " + resource.workingPeriodDayHrId);
                }
            }
            if (resource.dayPrId) {
                let dayPr = DayPrData.getById(resource.dayPrId);
                if (dayPr) {
                    dayPr.addActivity(activity);
                } else {
                    console.log("Activity.addLocally - DayPr not found given ID - DayPR ID: " + resource.dayPrId);
                }
            } else if (activity.workingPeriodDayPrId) {
                let workingPeriodDayPr = WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);
                if (workingPeriodDayPr) {
                    workingPeriodDayPr.addActivity(activity);
                } else {
                    console.log("Activity.addLocally - WorkingPeriodDayPr not found given ID - WorkingPeriodDayPr ID: " + resource.workingPeriodDayPrId);
                }
            }
            return activity;
        };

        activitySrv.getPreviousVersionInstance =  function(resource)
        {
            var activity =  new Activity(resource,true);
            if (resource.dayHrId)
                activity.dayHr = DayHrData.getById(resource.dayHrId);
            else
                if (activity.workingPeriodDayHrId)
                    activity.workingPeriodDayHrId= WorkingPeriodDayHrData.getById(resource.workingPeriodDayHrId);
            if (resource.dayPrId)
                activity.dayPr = DayPrData.getById(resource.dayPrId);
            else
            if (activity.workingPeriodDayPrId)
                activity.workingPeriodDayPrId= WorkingPeriodDayPrData.getById(resource.workingPeriodDayPrId);

            return activity;

        };

        return activitySrv;
    }]);

angular.module('FlexyBeautyApp.services').
    factory('ActivityData',["$log","ModelDataUtil", function ($log,ModelDataUtil)
    {
        var  activityData =
        {
            objActivities : {},
            indexActivities : []
        };
        activityData.getById = function(activityId, isApplicationLoading)
        {
            let activity = null;
            if(isApplicationLoading){
                activity = this.objActivities[activityId];
            }
            else {
                for (let i = 0; i < this.indexActivities.length; i++){
                    if (this.indexActivities[i].id === activityId) {
                        activity = this.indexActivities[i];
                        break;
                    }
                }
            }
            return activity;

        }
        activityData.getIndexOf =  function(activity)
        {
            if (activity)
                return this.indexActivities.indexOf(activity);
            return -1;
        }
        activityData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexActivities.length)
                return this.indexActivities[index];
            else
                return null;
        }
        activityData.add =  function(activity, isApplicationLoading)
        {
            if(isApplicationLoading){
                if(activity && activity.id){
                    this.objActivities[activity.id] = activity;
                }
            }
            else {
                this.indexActivities.push(activity);
            }
        };

        activityData.clear =  function(deleteNonRecurringOnly) {
            const recurrentActivities = deleteNonRecurringOnly ? activityData.indexActivities
                    .filter(activity => (activity.workingPeriodDayHr && !activity.dayHr) || (activity.workingPeriodDayPr && !activity.dayPr)) : [];

            activityData.indexActivities = recurrentActivities;
            activityData.objActivities = {};
        };

        activityData.convertMapToArray = function(keepObject, isNewLoading) {
            if (isNewLoading) {
                this.indexActivities = ModelDataUtil.convertObjectToArray(this.objActivities, this.indexActivities);
                if (!keepObject) {
                    this.objActivities = {};
                }
            } else {
                this.indexActivities = ModelDataUtil.convertMapToArray(this.objActivities, this.indexActivities);
                this.objActivities = null;
            }
        };

        return activityData;
    }]);





// WEBPACK FOOTER //
// ./js/services/models/Activity.js